import { brandNameOrDefault, formatBRL, formatDateTimeBR, receiptLogoHtml } from './print-receipt.util';

export interface ReimpressaoCartaoPix {
  nmPaciente: string;
  cpf: string;
  valor: number;
  dataHora: string;
  nrAdiantamento: number;
  observacao: string | null;
  usuario: string;
  logo: string;
  cdEmpresa: string;
  marca: string;
  estornado?: boolean;
}

// 2ª via de cartão/Pix a partir do histórico. Método, parcelas e terminal só existem no
// snapshot em memória da cobrança: para um adiantamento antigo não há esses dados.
export function montarReimpressaoCartaoPix(dados: ReimpressaoCartaoPix): string {
  const linhaObs = dados.observacao
    ? `<tr><td class="label">Observação</td><td class="value">${dados.observacao}</td></tr>`
    : '';
  const avisoEstorno = dados.estornado
    ? `<div class="obs-box" style="text-align:center;font-weight:bold;color:#991b1b;border-color:#991b1b;">ESTORNADO — valor devolvido ao paciente</div>`
    : '';

  return `
    <div class="header">
      <div class="logo">${receiptLogoHtml(dados.logo, dados.cdEmpresa)}</div>
      <div style="text-align: right;">
        <p class="title">Comprovante de Pagamento</p>
        <p class="subtitle">2ª via — Pagamento avulso</p>
        <p class="receipt-number">Nº ${dados.nrAdiantamento}</p>
      </div>
    </div>
    ${avisoEstorno}
    <table class="data">
      <tr><td class="label">Paciente</td><td class="value">${dados.nmPaciente || '—'}</td></tr>
      <tr><td class="label">CPF</td><td class="value">${dados.cpf || '—'}</td></tr>
      <tr><td class="label">Data/Hora</td><td class="value">${formatDateTimeBR(dados.dataHora)}</td></tr>
      ${linhaObs}
      <tr><td class="label">Usuário</td><td class="value">${dados.usuario}</td></tr>
    </table>
    <div class="valor-box">
      <div style="font-size: 10px; color: #626272;">Valor pago</div>
      <div class="amount">${formatBRL(dados.valor)}</div>
    </div>
    <div class="footer">${brandNameOrDefault(dados.marca)} — 2ª via — Comprovante sem valor fiscal</div>
  `;
}
